<div class="searchbar-whereapp">
    <button mat-flat-button id="back-toolbar-button" (click)="onBackButtonClick()">
        <mat-icon [inline]="true">chevron_left</mat-icon>
        Indietro
    </button>
    <!-- <button mat-flat-button id="save-geometry-button"  matTooltip="Salva Geometria"
        [matTooltipShowDelay]="600">
        <mat-icon [inline]="true">save</mat-icon>
    </button> -->
    <div id="insert-controls-div">
        <button mat-flat-button class="insert-button" (click)="onSaveClick()">
            <mat-icon [inline]="true">save</mat-icon>
            Salva
        </button>
    </div>
    <!-- <div id="pagination-div">
        <mat-paginator [hidePageSize]="true" [pageSize]="50" [showFirstLastButtons]="true">
        </mat-paginator>
    </div> -->
</div>

<mat-progress-bar mode="indeterminate" style="position: absolute; top: 68px; z-index: 27;" [hidden]="!this.loading">
</mat-progress-bar>

<div id="main-container">
    <app-area-draw (areaChange)="onAreaChange($event)"></app-area-draw>
</div>

<div class="loading" *ngIf="sub === true">
</div>